export default "__VITE_ASSET__DK0cWacX__"